import Image from "next/image";
import styled from "styled-components";
import {useDispatch, useSelector} from "react-redux";
import Icon from "@mdi/react";
import {mdiArrowLeft} from "@mdi/js";
import {GET_USER_STEP, SET_USER_STEP} from "@/store/slices/appSlice";
import {GET_OFFER_TYPE} from "@/store/slices/offerSlice";
import useOfferDetailsVariant from "@/hooks/useOfferDetailsVariant";
import themes from "@/styles/themes";
import Events from "@/utils/Events";

const LogoDiv = styled.div`
  padding: 15px;
  text-align: center`

/**
 * Cabeçalho da variante de teste: "voltar" à esquerda e o logo à direita,
 * conforme o Zeplin. Quando não há step anterior o botão não aparece, mas o
 * espaço é mantido pra o logo não pular de posição entre os steps.
 */
const LogoRow = styled.div`
  padding: 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const BackButton = styled.button`
  display: inline-flex;
  align-items: center;
  border: none;
  background: none;
  padding: 0;
  cursor: pointer;
  font-size: 16px;
  color: ${themes.estadao};

  svg {
    margin-right: 4px;
  }
`

export default function Logo() {
    const dispatch = useDispatch()
    const current = useSelector(GET_USER_STEP)
    const offer_type = useSelector(GET_OFFER_TYPE)
    const isOfferHighlightVariant = useOfferDetailsVariant()
    const events = new Events()

    if (isOfferHighlightVariant !== true) {
        return (
            <LogoDiv>
                <Image src={'/imgs/logo-estadao.svg'} alt={'Logo Estadão'} width={118} height={30}></Image>
            </LogoDiv>
        )
    }

    const finishStep = offer_type === 'impresso_digital' ? 4 : 3
    const canGoBack = current > 1 && current < finishStep

    const goBack = () => {
        events.trigger("detalhes_oferta_voltar", {offer_type, de: current, para: current - 1})
        dispatch(SET_USER_STEP(current - 1))
    }

    return (
        <LogoRow>
            {canGoBack
                ? <BackButton type={'button'} onClick={goBack}>
                    <Icon path={mdiArrowLeft} size={0.9}/>voltar
                </BackButton>
                : <span/>}
            <Image src={'/imgs/logo-estadao-lg.svg'} alt={'Logo Estadão'} width={146} height={37}></Image>
        </LogoRow>
    )
}
